export const INTRO_STEP = 1;
export const MANDATORY_PASSES_STEP = 2;
export const JETPASS_STEP = 3;
export const NAMING_STEP = 0;

export const DATE_PASS = 1;
export const TIME_PASS = 2;
export const QUEUE_PASS = 3;
